<template>
  <SubCustomersDatatable
    :source="source"
    :filters="filters"
    :customer-id="customerId"
    flat
    subpage
  />
</template>

<script setup lang="ts">
import SubCustomersDatatable from "@/Customer/Profile/SubCustomersDatatable.vue";

defineProps({
  source: {
    type: String,
    default: ""
  },
  filters: {
    type: Array,
    default: () => []
  },
  customerId: {
    type: Number,
    default: null
  }
});
</script>

<style lang="scss" scoped></style>
